'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactStyle = require('react-style');

var _reactStyle2 = _interopRequireDefault(_reactStyle);

var _utils = require('./utils');

var rippleUniqueId = 0;

var RippleContainerStyles = _reactStyle2['default'].create({
  normalStyle: {
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%'
  },

  rippleStyle: {
    display: 'block',
    position: 'absolute',
    background: 'rgba(0, 0, 0, 0.04)',
    borderRadius: '50%',
    transform: 'scale(0)',
    transition: 'transform .25s linear, opacity .25s linear .2s'
  },

  rippleAnimationStyle: {
    transform: 'scale(2)'
  },

  rippleFadeoutStyle: {
    opacity: '0'
  }
});

var _default = (function (_React$Component) {
  var _class = function _default(props) {
    _classCallCheck(this, _class);

    _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).call(this, props);
    this.state = {
      ripples: []
    };
  };

  _inherits(_class, _React$Component);

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_utils.transitionEnd) {
        return;
      }
      // TODO: make sure we only do this once, instead of all the time...
      _react2['default'].findDOMNode(this).addEventListener(_utils.transitionEnd, this.endRipple.bind(this));
    }
  }, {
    key: 'onMouseDown',
    value: function onMouseDown(e) {
      var domNode = _react2['default'].findDOMNode(this);
      var boundingRect = domNode.getBoundingClientRect();
      var height = domNode.offsetHeight;
      var width = domNode.offsetWidth;
      if (width > height) {
        height = width;
      } else {
        width = height;
      }
      var x = e.clientX - boundingRect.left - width / 2;
      var y = e.clientY - boundingRect.top - height / 2;

      var ripples = _utils.slice.call(this.state.ripples);
      var ripple = {
        id: rippleUniqueId++,
        height: height,
        width: width,
        x: x,
        y: y
      };
      ripples.push(ripple);

      this.setState({ ripples: ripples });

      setTimeout(this.startRipple.bind(this), 0);
    }
  }, {
    key: 'onMouseUp',
    value: function onMouseUp(e) {
      this.onMouseLeave();
      var onClick = this.props.onClick;

      if (onClick) {
        e.preventDefault();
        onClick({
          target: _react2['default'].findDOMNode(this).parentNode,
          originalEvent: e
        });
      }
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave() {
      // fade out
      var ripples = _utils.slice.call(this.state.ripples).map(function (ripple) {
        ripple.fadeOut = true;
        ripple.transitioning = false;
        ripple.transitionComplete = true;
        return ripple;
      });
      this.setState({ ripples: ripples });
    }
  }, {
    key: 'startRipple',
    value: function startRipple() {
      var ripples = _utils.slice.call(this.state.ripples);
      ripples[ripples.length - 1].transitioning = true;
      this.setState({ ripples: ripples });
    }
  }, {
    key: 'endRipple',
    value: function endRipple(e) {
      var ripples = _utils.slice.call(this.state.ripples);
      if ((0, _utils.isTransform)(e.propertyName)) {
        ripples[0].transitioning = false;
        ripples[0].transitionComplete = true;
        this.setState({ ripples: ripples });
      } else if (e.propertyName === 'opacity') {
        ripples.shift();
        this.setState({ ripples: ripples });
      }
    }
  }, {
    key: 'renderRipples',
    value: function renderRipples(ripples, styles, animateStyle) {
      var l = ripples.length;
      return ripples.map(function (ripple, index) {
        var rippleStyles = [styles];
        if (ripple.transitioning || ripple.transitionComplete) {
          rippleStyles.push(animateStyle);
        }

        if (index < l - 1 || ripple.transitionComplete && ripple.fadeOut) {
          rippleStyles.push({ opacity: '0' });
        }

        rippleStyles.push({
          height: ripple.height,
          left: ripple.x,
          top: ripple.y,
          width: ripple.width
        });

        return _react2['default'].createElement('div', {
          key: ripple.id,
          ref: 'ripple_' + ripple.id,
          styles: rippleStyles });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = this.props.styles;
      var ripples = this.state.ripples;
      var normalStyle = RippleContainerStyles.normalStyle;
      var rippleStyle = RippleContainerStyles.rippleStyle;
      var rippleAnimationStyle = RippleContainerStyles.rippleAnimationStyle;

      return _react2['default'].createElement(
        'div',
        {
          onMouseDown: !_utils.isTouchDevice ? this.onMouseDown.bind(this) : _utils.noop,
          onMouseLeave: !_utils.isTouchDevice ? this.onMouseLeave.bind(this) : _utils.noop,
          onMouseUp: !_utils.isTouchDevice ? this.onMouseUp.bind(this) : _utils.noop,

          onTouchCancel: _utils.isTouchDevice ? this.onMouseLeave.bind(this) : _utils.noop,
          onTouchEnd: _utils.isTouchDevice ? this.onMouseUp.bind(this) : _utils.noop,
          onTouchStart: _utils.isTouchDevice ? this.onMouseDown.bind(this) : _utils.noop,
          styles: [normalStyle, styles] },
        this.renderRipples(ripples, rippleStyle, rippleAnimationStyle)
      );
    }
  }], [{
    key: 'displayName',
    value: 'RippleContainer',
    enumerable: true
  }, {
    key: 'propTypes',
    value: {
      onClick: _react.PropTypes.func,
      styles: _react.PropTypes.object
    },
    enumerable: true
  }]);

  return _class;
})(_react2['default'].Component);

exports['default'] = _default;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-material/lib/RippleContainer.js
 ** module id = 212
 ** module chunks = 0
 **/